function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React, { useState, useRef } from 'react';
import { string, bool } from 'prop-types';
import cn from 'classnames';
import { colors } from '../colorSwatches';
import Label from '../label/Label';
import Error from '../error/Error';
import TextInputBase from './styles/TextInputBase';
/**
 * React component rendering TextInput
 * @function
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

function TextInput(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$noLabel = _ref.noLabel,
      noLabel = _ref$noLabel === void 0 ? false : _ref$noLabel,
      _ref$expand = _ref.expand,
      expand = _ref$expand === void 0 ? true : _ref$expand,
      setWidth = _ref.setWidth,
      setName = _ref.setName,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$validateNotEmpty = _ref.validateNotEmpty,
      validateNotEmpty = _ref$validateNotEmpty === void 0 ? false : _ref$validateNotEmpty,
      _ref$validateEmail = _ref.validateEmail,
      validateEmail = _ref$validateEmail === void 0 ? false : _ref$validateEmail,
      _ref$validatePassword = _ref.validatePassword,
      validatePassword = _ref$validatePassword === void 0 ? false : _ref$validatePassword,
      _ref$editError = _ref.editError,
      editError = _ref$editError === void 0 ? false : _ref$editError,
      errorText = _ref.errorText,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? undefined : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? undefined : _ref$dataAnalyticsLab,
      placeHolder = _ref.placeHolder,
      inputType = _ref.inputType;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFocused = _useState6[0],
      setIsFocused = _useState6[1];

  var inputEl = useRef(null);
  var emailValidation = !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(inputValue);
  var notEmptyValidation = inputValue.length === 0;
  var passwordValidation = inputValue.length >= 1 && inputValue.length <= 5;

  var validationCondition = function validationCondition(condition, text) {
    if (condition) {
      if (editError === true) {
        setError(["".concat(errorText)]);
      } else {
        setError([text]);
      }
    }
  };

  var isNotEmpty = function isNotEmpty() {
    if (validateNotEmpty === true) {
      validationCondition(notEmptyValidation, "".concat(setName, " is required."));
    }
  };

  var isEmail = function isEmail() {
    if (validateEmail === true) {
      validationCondition(emailValidation, "A valid ".concat(setName, " is required."));
    }
  };

  var isPassword = function isPassword() {
    if (validatePassword === true) {
      validationCondition(passwordValidation, "".concat(setName, " must be at least 6 characters long."));
    }
  };

  var focus = function focus() {
    setIsFocused(true);
  };

  var blur = function blur() {
    setIsFocused(false);
    isNotEmpty();
    isEmail();
    isPassword();
  };

  var onChangeFunc = function onChangeFunc(event) {
    setError(''); // add a validation method if you want the option to have the
    // validation message(s) remain while the user is typing

    setInputValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn('text-input', className),
    "data-analytics-id": dataAnalyticsId,
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "text-input",
    style: {
      width: expand === false && setWidth,
      display: 'flex',
      flexDirection: 'column'
    }
  }, noLabel === false ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    labelFor: setName,
    required: required,
    label: label,
    color: colors.charcoalDefault
  }, error && /*#__PURE__*/React.createElement(Error, {
    "data-test-id": "error",
    errorColor: colors.error
  }, error), /*#__PURE__*/React.createElement(TextInputBase, {
    name: setName,
    maxLength: "200",
    size: "20",
    title: setName,
    className: "scl-input",
    "data-test-id": "input",
    type: inputType,
    value: inputValue,
    onChange: onChangeFunc,
    onFocus: focus,
    onBlur: blur,
    autoComplete: "off",
    ref: inputEl,
    "aria-label": setName,
    style: {
      border: error && "1px solid ".concat(colors.error)
    },
    bgColor: colors.white,
    placeholder: placeHolder
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Error, {
    "data-test-id": "error",
    errorColor: colors.error
  }, error), /*#__PURE__*/React.createElement(TextInputBase, {
    name: setName,
    maxLength: "200",
    size: "20",
    title: setName,
    className: "scl-input",
    "data-test-id": "input",
    type: inputType,
    value: inputValue,
    onChange: onChangeFunc,
    onFocus: focus,
    onBlur: blur,
    autoComplete: "off",
    ref: inputEl,
    "aria-label": setName,
    style: {
      border: error && "1px solid ".concat(colors.error)
    },
    bgColor: colors.white,
    placeholder: placeHolder
  })));
}

TextInput.propTypes = {
  /**
   * Set a input's name
   */
  setName: string.isRequired,

  /**
   * Define label's text.
   */
  label: string,

  /**
   * Define label's htmlFor.
   */
  htmlFor: string,

  /**
   * Define input type
   */
  inputType: string,

  /**
   * Define data analytics label.
   */
  dataAnalyticsLabel: string,

  /**
   * Define data analytics id.
   */
  dataAnalyticsId: string,

  /**
   * Define additional classNames.
   */
  className: string,

  /**
   * Define a placeholder copy.
   */
  placeHolder: string,

  /**
   * Define if component requires a label
   */
  noLabel: bool,

  /**
   * Define if input width is 100%.
   */
  expand: bool,

  /**
   * Set a input width (expand must be set to false).
   */
  setWidth: string,

  /**
   * Choose to make input required
   */
  required: bool,

  /**
   * Choose to validate if value is notEmpty
   */
  validateNotEmpty: bool,

  /**
   * Choose to validate email
   */
  validateEmail: bool,

  /**
   * Choose to validate password
   */
  validatePassword: bool,

  /**
   * Choose to customize error message
   */
  editError: bool,

  /**
   * Customize error text
   */
  errorText: string
};
export default TextInput;